import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import css from './index.module.scss';
import { CanvasKeyFrames } from '@/utils/canvaskeyframes';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import { handleDynamicPath } from '@/utils/handleDynamicPath';

const { EFPic } = createEFPic('/media/deltapro/pc/');
gsap.registerPlugin(ScrollTrigger);
export default function Section15() {
    const { useEffect, useRef, useLang } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const ref = useRef();

    const createImgs = () => {
        const imageEleArr: any[] = [];
        const imageCount = 60;
        return new Promise((resolve, reject) => {
            let loadImageCount = 0;
            for (let i = 0; i < imageCount; i++) {
                const imageEle = new Image();
                imageEleArr.push(imageEle);
                imageEle.onload = function () {
                    loadImageCount++;
                    if (loadImageCount >= imageCount) {
                        // 此时图片全部加载完成
                        resolve(imageEleArr);
                    }
                };
                imageEle.onerror = reject;

                imageEle.src = handleDynamicPath(`/media/deltapro/pc/P9-P13/animaImage/wing_000${i < 10 ? `0${i}` : i}.png`);
            }
        });
    };
    useEffect(() => {
        const container = ref.current;
        let canvasKeyFramesInstance: any = null;
        const tlList: any[] = [];
        const TL1 = gsap.timeline({
            scrollTrigger: {
                trigger: '.sec15-container .head',
                start: 'top-=200 bottom',
                end: '+=100',
                once: true,
                onEnter() {
                    const container = document.getElementById('animation');
                    if (!container) return;
                    createImgs().then((imgArr) => {
                        // @ts-ignore
                        canvasKeyFramesInstance = new CanvasKeyFrames(container, 'array', imgArr, {
                            width: 545,
                            height: 840,
                            fps: 30,
                        });
                        canvasKeyFramesInstance.play();
                    });
                },
            },
        });
        tlList.push(TL1);

        const TL2 = gsap.timeline({
            scrollTrigger: {
                trigger: container.querySelector('.sec15-container .bottom .img'),
                start: 'center bottom',
                end: '+=500',
                scrub: 0.2,
            },
        });
        tlList.push(TL2);
        TL2.to('.bottom .img_2', {
            x: -233,
            y: -231,
            duration: 1,
        });
        TL2.to(
            '.bottom .img_3',
            {
                x: -123,
                y: -117,
                duration: 1,
            },
            '-=1',
        );

        return () => {
            tlList.forEach((v) => {
                v?.kill();
            });
            canvasKeyFramesInstance?.destroy();
        };
    }, []);
    return (
        <div
            ref={ref}
            className={`${css.section15} sec15-container GtmModuleData-section`}
            data-section-id={css.section15}
            data-section-title={t.rich('interior_exterior_design_sub_title', {
                line1: (child: string) => child,
                line2: (child: string) => child,
                line3: (child: string) => child,
            })}
        >
            <div className="head">
                <h4 className="subTitle font-family-extrabold">{t('interior_exterior_design')}</h4>
                <h2 className="mainTitle font-family-extrabold">
                    {t.rich('interior_exterior_design_sub_title', {
                        line1: (child: string) => <div>{child}</div>,
                        line2: (child: string) => <div>{child}</div>,
                        line3: (child: string) => <span style={{ color: '#fbd412' }}>{child}</span>,
                    })}
                </h2>
                <p className="text font-family-semibolder">{t('interior_exterior_design_desc')}</p>
            </div>
            <div className="center">
                <div className="item">
                    <div className="bg">
                        <EFPic name={['section_15_1.webp', 'section_15_1.png']} alt={t('interior_design')} />
                    </div>
                    <div id="animation"></div>
                    <div className="content">
                        <h3 className="title font-family-semibolder">{t('interior_design')}</h3>
                        <p className="desc font-family-semibolder">{t('interior_design_desc')}</p>
                    </div>
                </div>
                <div className="item">
                    <div className="bg">
                        <EFPic name={['section_15_2.webp', 'section_15_2.png']} alt={t('exterior_design')} />
                    </div>
                    <div className="content">
                        <h3 className="title font-family-semibolder">{t('exterior_design')}</h3>
                        <p className="desc font-family-semibolder">{t('exterior_design_desc')}</p>
                    </div>
                </div>
            </div>
            <div className="bottom">
                <div className="img">
                    <div className="img_2">
                        <div className="bottomImg">
                            <EFPic name={['section_15_4.webp', 'section_15_4.png']} width={1120} height={559} />
                        </div>
                    </div>
                    <div className="img_3">
                        <div className="bottomImg">
                            <EFPic name={['section_15_5.webp', 'section_15_5.png']} width={1120} height={559} />
                        </div>
                    </div>
                    <div className="img_main">
                        <div className="bottomImg">
                            <EFPic name={['section_15_3.webp', 'section_15_3.png']} width={1120} height={559} />
                        </div>
                    </div>
                </div>
                <div className="text">
                    <h3 className="title font-family-semibolder">{t('portability')}</h3>
                    <p className="desc font-family-semibolder">{t('portability_desc')}</p>
                </div>
            </div>
        </div>
    );
}
